import RolePage from './role/index'
import UserPage from './user/index'
import AuditPage from './audit/index'

const routes: IRoute[] = [
	{
		path: '/000101',
		component: RolePage,
		name: '角色管理',
	},

	{
		path: '/000102',
		component: UserPage,
		name: '组织用户',
	},

	{
		path: '/000112',
		component: AuditPage,
		name: '系统日志',
	},
]

export default routes



// WEBPACK FOOTER //
// ./src/page/application/index.ts